export default "__VITE_ASSET__b8f323af__"